import { i18next } from '@yola/ws-sdk';
import { ROOT_ID } from '../constants/index.js';

const buildFolderOptions = (folders) => {
  const folderIds = new Set(folders.map((folder) => folder.id));
  const childrenByParentId = new Map();

  const getParentKey = (folder) =>
    folder.parentFolderId && folderIds.has(folder.parentFolderId) ? folder.parentFolderId : null;

  const sortedFolders = [...folders].sort((a, b) => {
    const aName = (a.name || '').toLowerCase();
    const bName = (b.name || '').toLowerCase();
    return aName.localeCompare(bName);
  });

  sortedFolders.forEach((folder) => {
    const parentKey = getParentKey(folder);
    if (!childrenByParentId.has(parentKey)) {
      childrenByParentId.set(parentKey, []);
    }
    childrenByParentId.get(parentKey).push(folder);
  });

  const options = [
    {
      label: i18next.t('Root'),
      value: ROOT_ID,
    },
  ];

  const traverse = (parentKey) => {
    const children = childrenByParentId.get(parentKey) || [];
    children.forEach((folder) => {
      options.push({
        label: folder.name,
        value: folder.id,
      });
      traverse(folder.id);
    });
  };

  traverse(null);

  return options;
};

export default buildFolderOptions;
